import {AI_SUMMARY, ELITE_AI_CHAT, ELITE_AI_SUMMARY, PRINT_AI_SUMMARY} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";
import axios from "axios";
export const AiAssistantService= {
  async getAiSummary(params) {
    return axios.post(AI_SUMMARY, params).then(res => {
      return res.data ?? false
    }).catch(error => {
      return false
    })
  },
  async getEliteAiSummary(params, mode) {
    // let summaryUrl = ELITE_AI_CHAT;
    // if (mode !== 'string') {
    //   summaryUrl = ELITE_AI_SUMMARY;
    // }

    // let summaryUrl = 'https://elitesdsitestserver.com/qa_krbs_kids_api/public/api/kids/assistants/chat';
    let summaryUrl = ELITE_AI_CHAT;
    if (mode !== 'string') {
      // summaryUrl = 'https://elitesdsitestserver.com/qa_krbs_kids_api/public/api/kids/assistants/images/summarize';
      summaryUrl = ELITE_AI_SUMMARY;
    }

    return axios.post(summaryUrl, params).then(res => {
      return res.data ?? false
    }).catch(error => {
      return false
    })
  },
  async printAiSummary(params) {
    try {
      const response = await axios.post(PRINT_AI_SUMMARY, params, {
        headers: { "Content-Type": "application/json" },
        responseType: "blob" // Expect a PDF response
      });

      return response ?? false;
    } catch (error) {
      GlobalService.handleError(error, 'DOWNLOAD AI SUMMARY SERVICE');
      return false;
    }
  },
}
